<template>
    <v-container fluid>
    <field-form id="pfid1618854093" @save="save" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" @cancel="cancelWizard()" v-if="item">
      <h2 class="text-h4">Leadscoring Remarketing</h2>
      <v-card class="my-3">
      <v-card-text>
      <v-text-field id="pfid1618854096" v-model="fields.trackingIds.googleAnalytics" 
      label="Google Analytics ID"
      prepend-icon="$ganalytics"
      style="max-width:800px"
      class="pr-3"
      />
      <v-text-field id="pfid1618854099" v-model="fields.trackingIds.googleAdWords" 
      label="Google AdWords ID"
      prepend-icon="$gadwords"
      style="max-width:800px"
      class="pr-3"
      />
      <v-text-field id="pfid1618854102" v-model="fields.trackingIds.sklik" 
      label="Sklik ID"
      prepend-icon="$sklik"
      style="max-width:800px"
      class="pr-3"
      />
      <v-text-field id="pfid1618854106" v-model="fields.trackingIds.facebook" 
      label="Facebook ID"
      prepend-icon="$fb"
      style="max-width:800px"
      class="pr-3"
      />
      </v-card-text>
      </v-card>
      
    </field-form>
    </v-container>
</template>
<script>
  import EntityForm from "@/mixins/entity-form"
  import Wizards from "@/mixins/wizards"

  export default {
    name: 'Integrations',
    mixins: [EntityForm, Wizards],
    data() {
      return {
          endpoint: 'domains',
          help: false,
          fields: {
            trackingIds: null
          }
      };
    },
    methods: {
    }
  }
</script>